/**
 * Respectful under-18 gate. Reached ONLY after the backend rejects a
 * registration attempt with `code=under_minimum_age`. No PII is captured;
 * the backend already recorded an anonymous eligibility event.
 */
import { Link } from "react-router-dom";
import { CheckInShell, CheckInLogo, GhostButton, CHECKIN_PALETTE } from "./_shell";

export default function CheckInAdultsOnly() {
  return (
    <CheckInShell testid="checkin-adults-only">
      <div className="pt-2">
        <CheckInLogo small />
      </div>
      <div className="mt-16">
        <div className="text-[10px] font-semibold uppercase tracking-[0.28em]"
             style={{ color: CHECKIN_PALETTE.purple }}>
          Thank you for stopping by
        </div>
        <h1 className="mt-3 font-serif text-3xl leading-tight"
            style={{ color: CHECKIN_PALETTE.ink, fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
          Check In with Dr. C is currently for adults 18 and older.
        </h1>
        <p className="mt-4 text-[14px] leading-relaxed" style={{ color: "#4A4256" }}>
          We appreciate your interest. If you&rsquo;re a parent, guardian, or
          trusted adult who&rsquo;d like to explore what we&rsquo;re building,
          you&rsquo;re welcome to visit{" "}
          <a href="https://christyvonta.com" className="underline"
             style={{ color: CHECKIN_PALETTE.purple }}
             target="_blank" rel="noopener noreferrer">
            ChristyVonta.com
          </a>.
        </p>
      </div>
      <div className="mt-auto pt-10">
        <Link to="/checkin">
          <GhostButton testid="adults-only-back">Return to welcome</GhostButton>
        </Link>
      </div>
    </CheckInShell>
  );
}
